export const AVATAR_STATUSES = {
    'default': 0,
    'free': 1,
    'denied': 2
};
